/*
 * @description: 投标管理路由设置
 * @author: Vincent
 * @since: 2022-03-31 11:03:46
 * @version: 1.0
 */
import HomeLayout from '@/app/home/views/components/HomeLayout.vue'
export default [
  {
    path: '/bid',
    component: HomeLayout,
    children: [
      // 我的代办
      {
        path: 'todo',
        component: () => import('@/app/bid/views/todo'),
        name: 'Todo',
        meta: { title: 'module.bid.098672-0', icon: 'guide', keepAlive: true, whiteList:true}
      }
    ]
  }

]
